import { render, staticRenderFns } from "./TfaResetProcess.vue?vue&type=template&id=2c33fdfc&"
import script from "./TfaResetProcess.vue?vue&type=script&lang=js&"
export * from "./TfaResetProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports